import React, { useEffect, useState } from "react";
import * as R from "ramda";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import styled, { css } from "styled-components";
import {
  SectionContainer,
  Card,
  CardLabel,
  ColumnsRow,
} from "../ui/RecordLayout";
import Offcanvas from "react-bootstrap/Offcanvas";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import {
  Images,
  Plus,
  Trash,
  SortDown,
  SortUp,
  ExclamationTriangle,
  Rulers,
} from "react-bootstrap-icons";
import { getPhotoForUserId } from "../../utils/utils";
import PhotoSelect from "../ui/PhotoSelect";
import ConfirmDelete from "../ui/ConfirmDelete";
import {
  getCustomer,
  customerPrint,
  setCustomerGallery,
  deleteCustomerGallery,
} from "../bowlers/bowlers.redux";
import {
  specsheetSetSpecsheets,
  specsheetSetSpecsheet,
  specsheetSVGClick,
  specsheetAddNew,
  specsheetClone,
  specsheetCalculateThumbCuts,
  specsheetAddThumbCut,
  specsheetUpdateThumbCut,
  specsheetDeleteThumbCut,
  specsheetSetThumbCuts,
  specsheetSavePhoto,
  specsheetScanPhoto,
  specsheetScanPhotoAI,
  specsheetDeletePhoto,
  specsheetShowThumbcutModal,
  specsheetHandleForm,
  specSheetRemove,
  specSheetGetAuditRecords,
  specSheetSendEmail,
  setShowSharingModal,
} from "../specsheet/specsheet.redux";
import BowlerTable from "./BowlerTable";
import { CarouselArsenal } from "./CarouselArsenal";
import { SpecsContinued } from "./SpecsContinued";
import { Specsheet } from "../specsheet/specsheet";
import Spinner from "../ui/Spinner";
import { ballAddNew, ballSelect } from "../arsenal/arsenal.redux";
import { ContainerMod as ArsenalContainerMod } from "../ui/ArsenalCard";
import { BowlerHeader, HeaderActionButton } from "../ui/BowlerHeader";
import { WizardModal } from "../wizard/WizardModal";
import { WizardOffer } from "../wizard/WizardOffer";
import { WIZARD_ENABLED } from "../wizard/wizardSteps";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  margin: 0;
  width: 100%;
  height: auto;
  background: #ffffff;
  margin-bottom: 1em;

  ${(props) =>
    props.specSheets &&
    css`
    order: 2;
    display: 'flex',
    justify-content: 'center',
    width: 100%;

    @media only screen and (min-width: 992px) and (orientation: landscape) {
      flex: 1 1 0;
      min-height: 0;
      height: 100%;
      overflow: hidden;
      margin-bottom: 0;
    }

    @media only screen and (min-width: 1200px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
      width: 100%;
    }

    @media only screen and (min-width: 768px) and (max-width: 992px) and (orientation: portrait) {
      width: 100%;
    }
  `}
  ${(props) =>
    props.specSheetsContinued &&
    css`
      width: 100%;
      text-align: center;
      padding: 0;
      min-width: 0;
      overflow: hidden;

      & [class*="col-"] {
        padding-left: 0;
        padding-right: 0;
        width: 100%;
        min-width: 0;
      }
      & .row {
        margin-left: 0;
        margin-right: 0;
        width: 100%;
        min-width: 0;
      }


      @media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
        margin: 2vh auto;
        max-width: 100%;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      @media only screen and (min-width: 768px) and (max-width: 992px) and (orientation: portrait) {
        margin: 2vh auto;
        max-width: 100%;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    `}
  ${(props) =>
    props.arsenal &&
    css`
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: start;
      padding: 0;
      margin: 0 auto;
      height: 100%;
      height: -webkit-fill-available;
      overflow: hidden;
      background: #ffffff;
      margin-bottom: 1em;

      width: 100%;

      @media only screen and (min-width: 992px) and (orientation: landscape) {
        height: auto;
        overflow: visible;
      }

      @media only screen and (min-width: 992px) and (max-width: 1439px) and (orientation: landscape) {
        && span {
          font-size: 11px;
        }
      }

      @media only screen and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
        margin: 2vh auto;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        overflow: visible;
        height: auto;
        flex-wrap: nowrap;
      }

      @media only screen and (orientation: portrait) {
        margin: 2vh auto;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        overflow: visible;
        height: auto;
        flex-wrap: nowrap;
      }
    `}
`;

const Marginrules = styled.div`
  width: 100%;
  position: absolute;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  height: -webkit-fill-available;

  @media only screen and (min-width: 992px) and (orientation: landscape) {
    overflow: hidden;
  }

  @media only screen and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
    margin-bottom: 4em;
  }

  @media only screen and (orientation: portrait) {
    margin-bottom: 4em;
  }

  & .row {
    width: 100%;
    margin: 0;
  }
`;

const tabletPortrait = "(min-width: 768px) and (orientation: portrait)";

// In tablet portrait the arsenal lives in a wider area, so pack the ball
// cards three-per-row instead of one. Scoped to this screen — ArsenalScreen
// keeps its own width logic.
const ArsenalWrap = styled.div`
  width: 100%;

  @media ${tabletPortrait} {
    ${ArsenalContainerMod} {
      width: calc((100% - 16px) / 3);
      min-width: calc((100% - 16px) / 3);
    }
  }
`;

const ActionLabel = styled.span`
  display: none;
`;

const StyledLightboxModal = styled(Modal)`
  .modal-content {
    background-color: #ffffff;
    box-shadow: inset 0 4px 0 ${(p) => p.theme.color.primary},
      0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    border-radius: ${(p) => p.theme.radius.md};
    border: none;
  }
  .modal-header {
    border-bottom: 1px solid ${(p) => p.theme.color.border};
    padding: calc(${(p) => p.theme.spacing.md} + 4px)
      ${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.md};
  }
  .modal-body {
    padding: ${(p) => p.theme.spacing.md};
    min-height: 320px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f6fa;
  }
  .modal-footer {
    border-top: 1px solid ${(p) => p.theme.color.border};
    padding: ${(p) => p.theme.spacing.sm} ${(p) => p.theme.spacing.md};
  }
`;

const LightboxTitle = styled.span`
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeLg};
  font-weight: ${(p) => p.theme.font.weightSemibold};
  color: ${(p) => p.theme.color.primary};
  line-height: 1.2;
`;

const LightboxMedia = styled.div`
  width: 100%;
  max-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;

  & img,
  & video {
    max-width: 100%;
    max-height: 70vh;
    width: auto;
    height: auto;
    display: block;
    border-radius: ${(p) => p.theme.radius.md};
    background: #ffffff;
  }
`;

const LightboxEmpty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  min-height: 280px;
  color: ${(p) => p.theme.color.textMuted};
  font-family: ${(p) => p.theme.font.family};
  font-size: ${(p) => p.theme.font.sizeSm};

  svg {
    width: 32px;
    height: 32px;
    color: #c3c7d4;
  }
`;

const BowlerScreen = (props) => {
  const {
    arsenal_layout_style,
    loadingCustomer,
    bowler,
    getCustomer,
    userId,
    isOval,
    specsheet,
    specsheets,
    isOvalCalculationVisible,
    isRightHander,
    specsheetSVGClick,
    specsheetAddNew,
    specsheetClone,
    customerPrint,
    balls_drilled,
    specsheetCalculateThumbCuts,
    hideNotesBadge,
    ballAddNew,
    ballSelect,
    specsheetAddThumbCut,
    specsheetUpdateThumbCut,
    specsheetDeleteThumbCut,
    specsheetSetThumbCuts,
    specsheetSetSpecsheet,
    specsheetSavePhoto,
    specsheetScanPhoto,
    specsheetScanPhotoAI,
    specsheetDeletePhoto,
    specsheetShowThumbcutModal,
    showThumbcutModal,
    specSheetRemove,
    specsheetHandleForm,
    isOvalWidthDifference,
    isOvalWidthDecimal,
    isOvalWidthStartingBit,
    isCalculating,
    pluginSubscriptions,
    isReadOnly,
    flip_vh,
    default_vacu,
    default_vacu_increment,
    is2Hander,
    isPortrait,
    specSheetGetAuditRecords,
    spanMeasurement,
    savingPhotoAI,
    specSheetSendEmail,
    setShowSharingModal,
    setCustomerGallery,
    deleteCustomerGallery,
  } = props;
  const params = useParams();
  const bowlerID = params.bowlerID;
  const { t } = useTranslation();
  const [showGalleryDrawer, setShowGalleryDrawer] = useState(false);
  const [showWizard, setShowWizard] = useState(false);
  const [lightboxFile, setLightboxFile] = useState(null);
  const [lightboxError, setLightboxError] = useState(false);
  const [showPhotoSelect, setShowPhotoSelect] = useState(false);
  const [confirmDeleteFile, setConfirmDeleteFile] = useState(null);

  useEffect(() => {
    setLightboxError(false);
  }, [lightboxFile]);
  const [tagFilter, setTagFilter] = useState("");
  const [mediaTypeFilter, setMediaTypeFilter] = useState("all");
  const [sortDesc, setSortDesc] = useState(true);

  const getPhoto = getPhotoForUserId(userId);

  const isVideoFile = (src) => {
    const ext = (src || "").toLowerCase().split("?")[0].split(".").pop();
    return ["mp4", "mov"].includes(ext);
  };

  const isImageFile = (src) => {
    const ext = (src || "").toLowerCase().split("?")[0].split(".").pop();
    return ["png", "jpg", "jpeg"].includes(ext);
  };

  const tagOf = (src) => {
    const parts = (src || "").split("_");
    return parts[6] || "";
  };

  const filterAndSortGallery = (files) => {
    let out = files || [];
    if (mediaTypeFilter === "images") out = out.filter(isImageFile);
    else if (mediaTypeFilter === "videos") out = out.filter(isVideoFile);
    if (tagFilter.trim()) {
      const q = tagFilter.trim().toLowerCase();
      out = out.filter((s) => tagOf(s).toLowerCase().includes(q));
    }
    out = [...out].sort();
    return sortDesc ? out.reverse() : out;
  };

  const groupGalleryByDate = (files) => {
    const groups = {};
    files.forEach((fileName) => {
      const match = fileName.match(/\d{8}/);
      const date = match ? match[0] : "Unknown Date";
      if (!groups[date]) groups[date] = [];
      groups[date].push(fileName);
    });
    return groups;
  };

  const formatGalleryDate = (date) => {
    if (date === "Unknown Date") return date;
    return `${date.slice(0, 4)}/${date.slice(4, 6)}/${date.slice(6, 8)}`;
  };

  useEffect(() => {
    if (!loadingCustomer) {
      getCustomer({ customer_id: bowlerID });
    }
  }, []);

  if (loadingCustomer || R.isNil(bowler)) return <Spinner />;

  const hasGallery = pluginSubscriptions.indexOf("BOWLER_PLUS") >= 0;

  // Measuring needs a sheet to write on. A bowler who has none yet gets one
  // made here rather than being sent back to find the button for it.
  const openWizard = () => {
    if (specsheets.length === 0) specsheetAddNew();
    setShowWizard(true);
  };

  return (
    <Marginrules>
      <BowlerHeader
        autoOpenIfIncomplete
        actions={
          <>
            {WIZARD_ENABLED && !isReadOnly && (
              <HeaderActionButton
                secondary
                onClick={openWizard}
                title={t("wizard.action.open", "Guided measuring")}
                aria-label={t("wizard.action.open", "Guided measuring")}
              >
                <Rulers />{" "}
                <ActionLabel>
                  {t("wizard.action.open", "Guided measuring")}
                </ActionLabel>
              </HeaderActionButton>
            )}
            {hasGallery && (
              <HeaderActionButton
                secondary
                onClick={() => setShowGalleryDrawer(true)}
                title={t("Media Gallery")}
                aria-label={t("Media Gallery")}
              >
                <Images /> <ActionLabel>{t("Media Gallery")}</ActionLabel>
              </HeaderActionButton>
            )}
          </>
        }
      />
      {WIZARD_ENABLED && (
        <WizardModal show={showWizard} onHide={() => setShowWizard(false)} />
      )}
      {WIZARD_ENABLED && !showWizard && <WizardOffer onAccept={openWizard} />}
      <Offcanvas
        show={showGalleryDrawer}
        onHide={() => setShowGalleryDrawer(false)}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{t("Media Gallery")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body style={{ display: "flex", flexDirection: "column" }}>
          <div
            style={{
              display: "flex",
              gap: 8,
              alignItems: "center",
              marginBottom: 12,
              flexWrap: "wrap",
            }}
          >
            <Form.Control
              size="sm"
              placeholder={t("Tag Filter")}
              value={tagFilter}
              onChange={(e) => setTagFilter(e.target.value)}
              style={{ flex: "1 1 120px", minWidth: 0 }}
            />
            <Form.Select
              size="sm"
              value={mediaTypeFilter}
              onChange={(e) => setMediaTypeFilter(e.target.value)}
              style={{ flex: "0 0 110px" }}
            >
              <option value="all">{t("All")}</option>
              <option value="images">{t("Images")}</option>
              <option value="videos">{t("Videos")}</option>
            </Form.Select>
            <button
              onClick={() => setSortDesc((v) => !v)}
              title={sortDesc ? t("Newest first") : t("Oldest first")}
              style={{
                background: "#ffffff",
                border: "1px solid #c3c7d4",
                borderRadius: 8,
                padding: "0 10px",
                color: "#00187e",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: 36,
              }}
            >
              {sortDesc ? <SortDown /> : <SortUp />}
            </button>
          </div>
          {(() => {
            const filtered = filterAndSortGallery(bowler.gallery);
            const placeholderCard = !isReadOnly && (
              <button
                key="__add_placeholder"
                onClick={() => setShowPhotoSelect(true)}
                title={t("Add File")}
                style={{
                  aspectRatio: "1 / 1",
                  borderRadius: 10,
                  border: "1.5px dashed #c3c7d4",
                  background: "#f5f6fa",
                  color: "#6b7280",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 4,
                  cursor: "pointer",
                  fontSize: 11,
                  fontWeight: 600,
                  padding: 8,
                  transition:
                    "background 0.15s ease, border-color 0.15s ease, color 0.15s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#ffffff";
                  e.currentTarget.style.borderColor = "#00187e";
                  e.currentTarget.style.color = "#00187e";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "#f5f6fa";
                  e.currentTarget.style.borderColor = "#c3c7d4";
                  e.currentTarget.style.color = "#6b7280";
                }}
              >
                <Plus size={22} />
                <span>{t("Add")}</span>
              </button>
            );
            if (filtered.length === 0) {
              return (
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: 6,
                  }}
                >
                  {placeholderCard}
                </div>
              );
            }
            const grouped = groupGalleryByDate(filtered);
            const sortedEntries = Object.entries(grouped).sort(([a], [b]) =>
              sortDesc ? b.localeCompare(a) : a.localeCompare(b)
            );
            return sortedEntries.map(([date, files], groupIdx) => (
                <div key={date} style={{ marginBottom: 16 }}>
                  <div
                    style={{
                      fontSize: 12,
                      fontWeight: 600,
                      color: "#00187e",
                      marginBottom: 6,
                    }}
                  >
                    {formatGalleryDate(date)}
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: 6,
                    }}
                  >
                    {files.map((src, idx) => {
                      const url = getPhoto(`${src}?ttl=${Date().toString()}`);
                      const video = isVideoFile(src);
                      const tag = tagOf(src);
                      return (
                        <div
                          key={idx}
                          style={{
                            position: "relative",
                            aspectRatio: "1 / 1",
                            overflow: "hidden",
                            borderRadius: 6,
                            background: "#f0f1f6",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            setLightboxFile({ src, url, video })
                          }
                        >
                          {video ? (
                            <video
                              src={url}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                pointerEvents: "none",
                              }}
                            />
                          ) : (
                            <img
                              src={url}
                              alt=""
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          )}
                          {tag && (
                            <div
                              style={{
                                position: "absolute",
                                bottom: 0,
                                left: 0,
                                right: 0,
                                background:
                                  "linear-gradient(transparent, rgba(0,0,0,0.6))",
                                color: "#fff",
                                fontSize: 10,
                                padding: "8px 4px 3px",
                                textAlign: "center",
                              }}
                            >
                              #{tag}
                            </div>
                          )}
                        </div>
                      );
                    })}
                    {groupIdx === 0 && placeholderCard}
                  </div>
                </div>
              ));
          })()}
        </Offcanvas.Body>
      </Offcanvas>
      {showPhotoSelect && (
        <PhotoSelect
          circle={false}
          show={showPhotoSelect}
          includeTag={true}
          showVideo={true}
          onHide={() => setShowPhotoSelect(false)}
          onFromCamera={(imageBase64, extension, tag) => {
            setCustomerGallery({
              imageBase64,
              extension: extension || "png",
              tag: tag || "",
            });
            setShowPhotoSelect(false);
          }}
          onFromGallery={(imageBase64, extension, tag) => {
            setCustomerGallery({
              imageBase64,
              extension: extension || "png",
              tag: tag || "",
            });
            setShowPhotoSelect(false);
          }}
          onFromVideo={(video, extension, tag) => {
            fetch(video)
              .then((response) => response.blob())
              .then((blob) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                  const base64data = reader.result.split(";base64,");
                  setCustomerGallery({
                    imageBase64: base64data[1],
                    extension: extension || "mp4",
                    tag: tag || "",
                  });
                  setShowPhotoSelect(false);
                };
                reader.readAsDataURL(blob);
              })
              .catch((error) => {
                console.error("Error converting video Blob to Base64:", error);
                setShowPhotoSelect(false);
              });
          }}
        />
      )}
      <StyledLightboxModal
        show={!!lightboxFile}
        onHide={() => setLightboxFile(null)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <LightboxTitle>
            {lightboxFile?.video ? t("Video Preview") : t("Image Preview")}
          </LightboxTitle>
        </Modal.Header>
        <Modal.Body>
          {!lightboxFile?.url || lightboxError ? (
            <LightboxEmpty>
              <ExclamationTriangle />
              <span>
                {!lightboxFile?.url
                  ? t("No media available")
                  : t("Could not load this file")}
              </span>
            </LightboxEmpty>
          ) : lightboxFile?.video ? (
            <LightboxMedia>
              <video
                src={lightboxFile?.url}
                controls
                autoPlay
                onError={() => setLightboxError(true)}
              />
            </LightboxMedia>
          ) : (
            <LightboxMedia>
              <img
                src={lightboxFile?.url}
                alt=""
                onError={() => setLightboxError(true)}
              />
            </LightboxMedia>
          )}
        </Modal.Body>
        {!isReadOnly && lightboxFile && (
          <Modal.Footer>
            <button
              onClick={() => {
                setConfirmDeleteFile(lightboxFile.src);
              }}
              style={{
                background: "transparent",
                border: "1px solid #fdd",
                borderRadius: 6,
                padding: "6px 12px",
                color: "#d33",
                display: "inline-flex",
                alignItems: "center",
                gap: 4,
              }}
            >
              <Trash /> {t("Delete")}
            </button>
          </Modal.Footer>
        )}
      </StyledLightboxModal>
      <ConfirmDelete
        show={!!confirmDeleteFile}
        onHide={() => setConfirmDeleteFile(null)}
        confirmButtonText={
          confirmDeleteFile && isVideoFile(confirmDeleteFile)
            ? "message.confirm.deleteVideo"
            : "message.confirm.deleteImage"
        }
        confirmDescription={
          confirmDeleteFile && isVideoFile(confirmDeleteFile)
            ? "message.confirm.confirmDeleteVideo"
            : "message.confirm.confirmDeleteImage"
        }
        onConfirmClick={() => {
          deleteCustomerGallery({ fileName: confirmDeleteFile });
          setConfirmDeleteFile(null);
          setLightboxFile(null);
        }}
      />
      <ColumnsRow>
        <SectionContainer specsheet>
          <Card fillHeight>
            <Container specSheets>
            <Specsheet
              specsheets={specsheets}
              specsheetAddNew={specsheetAddNew}
              specsheetClone={specsheetClone}
              customerPrint={customerPrint}
              hideNotesBadge={hideNotesBadge}
              specsheetSVGClick={specsheetSVGClick}
              isRightHander={isRightHander}
              currentSpecsheet={specsheet}
              userId={userId}
              specsheetSetSpecsheet={specsheetSetSpecsheet}
              specsheetSavePhoto={specsheetSavePhoto}
              specsheetScanPhoto={specsheetScanPhoto}
              specsheetScanPhotoAI={specsheetScanPhotoAI}
              specsheetDeletePhoto={specsheetDeletePhoto}
              specSheetRemove={specSheetRemove}
              isReadOnly={isReadOnly}
              balls={balls_drilled}
              bowlerID={bowlerID}
              specSheetGetAuditRecords={specSheetGetAuditRecords}
              pluginSubscriptions={pluginSubscriptions}
              savingPhotoAI={savingPhotoAI}
              specSheetSendEmail={specSheetSendEmail}
              userEmail={bowler?.email}
              setShowSharingModal={setShowSharingModal}
              notesAtBottom={true}
            />
            </Container>
          </Card>
        </SectionContainer>
        <SectionContainer right>
          {!is2Hander && specsheets.length > 0 && (
            <Card>
              <CardLabel>Oval Calculator</CardLabel>
              <Container specSheetsContinued>
              <SpecsContinued
                specsheet={specsheet}
                flip_vh={flip_vh}
                default_vacu={default_vacu}
                default_vacu_increment={default_vacu_increment}
                isOval={isOval}
                isOvalCalculationVisible={isOvalCalculationVisible}
                specsheetSVGClick={specsheetSVGClick}
                isRightHander={isRightHander}
                specsheetCalculateThumbCuts={specsheetCalculateThumbCuts}
                specsheetAddThumbCut={specsheetAddThumbCut}
                specsheetUpdateThumbCut={specsheetUpdateThumbCut}
                specsheetDeleteThumbCut={specsheetDeleteThumbCut}
                specsheetSetThumbCuts={specsheetSetThumbCuts}
                specsheetShowThumbcutModal={specsheetShowThumbcutModal}
                showThumbcutModal={showThumbcutModal}
                specsheetHandleForm={specsheetHandleForm}
                isOvalWidthDifference={isOvalWidthDifference}
                isOvalWidthDecimal={isOvalWidthDecimal}
                isOvalWidthStartingBit={isOvalWidthStartingBit}
                isCalculating={isCalculating}
                isReadOnly={isReadOnly}
                is2Hander={is2Hander}
                spanMeasurement={spanMeasurement}
                customerHand={bowler?.hand}
              />
            </Container>
            </Card>
          )}
          <Card>
            <ArsenalWrap>
              <Container arsenal is2Hander={is2Hander}>
                <CarouselArsenal
                  balls_drilled={balls_drilled}
                  userId={userId}
                  arsenal_layout_style={arsenal_layout_style}
                  ballAddNew={ballAddNew}
                  ballSelect={ballSelect}
                  isReadOnly={isReadOnly}
                  is2Hander={is2Hander}
                  isPortrait={isPortrait}
                />
              </Container>
            </ArsenalWrap>
          </Card>
        </SectionContainer>
      </ColumnsRow>
    </Marginrules>
  );
};

export default connect(
  (state) => {
    const omitEmptyFields = (val) => val !== "";
    const initialValues = R.pipe(
      R.pickBy(omitEmptyFields),
      R.omit(["updated_at", "created_at"])
    )(state.specsheet.currentSpecSheet);
    const isOval = R.path(["thm_type"])(initialValues) === "Oval";

    return {
      initialValues,
      isPhone: state.userSession.deviceInfo.isMobileDevice,
      bowler: state.bowlers.selectedCustomer,
      specsheets: state.specsheet.specsheets,
      specsheet: state.specsheet.currentSpecSheet,
      loadingCustomer: state.bowlers.loadingCustomer,
      userId: state.userSession.userData.id,
      isOval,
      flip_vh: state.settings.appSettings.thumbHolePreferences.flip_vh,
      default_vacu: state.settings.appSettings.systemDefault.default_vacu,
      default_vacu_increment:
        state.settings.appSettings.systemDefault.default_vacu_increment,
      isOvalCalculationVisible:
        isOval &&
        state.settings.appSettings.thumbHolePreferences.oval_calculation !==
          "manual",
      isOvalWidthDifference:
        isOval &&
        state.settings.appSettings.thumbHolePreferences
          .oval_width_difference === "0",
      isOvalWidthDecimal:
        isOval &&
        state.settings.appSettings.thumbHolePreferences
          .oval_width_difference === "decimal",
      isOvalWidthStartingBit:
        isOval &&
        state.settings.appSettings.thumbHolePreferences
          .oval_width_difference === "64th",
      spanMeasurement:
        state.settings.appSettings.systemDefault.span_measurement,
      isRightHander: state.specsheet.currentSpecSheet
        ? state.specsheet.currentSpecSheet.hand === "right_hander"
        : true,
      balls_drilled: state.bowlers.selectedCustomer?.balls_drilled,
      hideNotesBadge: !state.specsheet.hideNotesBadge,
      arsenal_layout_style:
        state.settings.appSettings.layoutPreferences.arsenal_layout_style,
      showThumbcutModal: state.specsheet.showThumbcutModal,
      isCalculating: state.specsheet.isCalculating,
      isReadOnly: state.userSession.isReadOnly,
      isPortrait: state.userSession.deviceInfo.isPortrait,
      pluginSubscriptions: state.plugin.pluginSubscriptions,
      is2Hander:
        state.bowlers.selectedCustomer?.style === "two_handed" ||
        state.bowlers.selectedCustomer?.style === "thumbless",
      savingPhotoAI: state.specsheet.savingPhotoAI,
    };
  },
  {
    getCustomer,
    setCustomerGallery,
    deleteCustomerGallery,
    specsheetSetSpecsheets,
    specsheetSetSpecsheet,
    specsheetSVGClick,
    specsheetAddNew,
    specsheetClone,
    customerPrint,
    specsheetCalculateThumbCuts,
    ballAddNew,
    ballSelect,
    specsheetAddThumbCut,
    specsheetUpdateThumbCut,
    specsheetDeleteThumbCut,
    specsheetSetThumbCuts,
    specsheetSavePhoto,
    specsheetScanPhoto,
    specsheetScanPhotoAI,
    specsheetDeletePhoto,
    specsheetShowThumbcutModal,
    specsheetHandleForm,
    specSheetRemove,
    specSheetGetAuditRecords,
    specSheetSendEmail,
    setShowSharingModal,
  }
)(BowlerScreen);
